<template>
  <div class="additional-actions-component d-flex align-center j-between">
    <div class="upselling d-flex align-center">
      <v-btn
        class="button-param"
        color="#4CAF50"
        depressed
        @click="showUpsaleWindow"
      >
        <font-awesome-icon icon="plus" />
      </v-btn>
      <span class="status-text">{{ upsaleLabel }}</span>
    </div>

    <v-btn
      class="button-promotions"
      :disabled="!basket.filial"
      depressed
      color="#3a3a3a"
      @click="togglePromotionsWindow"
    >
      <font-awesome-icon class="button-promotions-icon" icon="percent" />
      Акции
    </v-btn>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import orderEdit from '@/mixins/order-edit'

  export default {
    name: 'AdditionalActions',
    mixins: [orderEdit],
    computed: {
      ...mapState({
        upsaleLabel: state => state.newOrder.upsaleLabelText,
      }),
    },
    methods: {
      togglePromotionsWindow () {
        this.$store.commit(this.orderEditPrefix + '/realTogglePromotionsWindow')
        this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', undefined)
      },

      showUpsaleWindow () {
        this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', 'upsales')
        this.$store.commit(this.orderEditPrefix + '/setDrinkDetailsStatus', true)
      },
    },
  }
</script>

<style lang="less" scoped>
  .additional-actions-component {
    padding: 9px 12px;
    margin-bottom: 12px;
    background-color: #e6f2e6;
    border-radius: 10px;

    .upselling {
      margin-right: 20px;
    }

    .button-param {
      font-size: 1.78em;
      line-height: 1;
      width: 1.9em;
      height: 1.9em;
      min-width: 1.9em !important;
      padding: 0 !important;
      margin-right: 15px;
      color: #fff;
    }

    .status {
      font-size: 1.78em;
      color: #fff;
      flex-shrink: 0;
      background-color: #c3e2c3;
      border-radius: 50%;
      width: 2em;
      height: 2em;
      cursor: pointer;
      margin-left: 15px;
      &.active {
        background-color: #4CAF50;
      }

      &-text.big {
        font-size: 1.57em;
        font-weight: bold;
      }

      svg {
       /* width: 23px;
        height: 23px;*/
        /*.fill-svg(#ffffff);*/
      }
    }

    .button-promotions {
      font-size: 1em;
      line-height: 1;
      height: 3.38em !important;
      color: #fff;
      text-transform: none;
      max-width: 130px;
      border-radius: 10px;
      flex-grow: 1;

      &-icon {
        font-size: 0.9em;
        margin-right: 10px;
      }

    }
  }
</style>
